import React from 'react'

const AdminReports = () => {
  return (
    <div>
      AdminReports
    </div>
  )
}

export default AdminReports
